<template>
  <div class="channel" :class="`is-${landingType}`">
    <!-- <ff-loading v-if="loading" :loading="loading" :text="'Architecting Your Channel'"/> -->
    <div class="error" v-if="!loading && err">
      <h1 class="error-title">{{err.message}}</h1>
    </div>
    <div v-if="loading" class="channel-loading">
      <ff-skeleton :lines="3"/>
    </div>
    <div v-if="!loading && !err">
      <sidebar :preview="preview"/>
      <router-view class="channel-main" :preview="preview" :loading="loading"/>
    </div>
  </div>
</template>

<script>
import Sidebar from '../_Shared/Sidebar'
import FFSkeleton from '../DesignSystem/FFSkeleton'
import { mapState } from 'vuex'

export default {
  name: 'Channel',
  components: {
    Sidebar,
    'ff-skeleton': FFSkeleton
  },
  metaInfo () {
    if (!this.channel) return
    let channel = this.channel.name
    let desc = this.channel.description
    return {
      title: `${channel} | ${desc}`,
      meta: [
        {
          name: 'description',
          content: `Get unlimited access to ${channel} ? ${desc}`
        },
        {
          property: 'og:title',
          content: `${channel}`
        },
        {
          property: 'og:site_name',
          content: `${channel}`
        },
        {
          property: 'og:url',
          content: `${channel}.fanfolk.com`
        }
      ]
    }
  },
  methods: {
    loginOwner () {
      this.$router.push({name: 'signup'})
    },
    loadChannel () {
      this.$store.dispatch('fetchChannel', (data) => {
        this.loading = false
        if (data && data.err) {
          this.err = data
        }
        if (!this.$store.state.channel) {
          this.$router.push({name: 'signup'})
        }
      })
    }
  },
  computed: {
    ...mapState(['user', 'channel', 'channel_id']),
    preview () {
      return this.$route.query.preview
    },
    landingType () {
      if (!this.channel || !this.channel.landing || !this.channel.landing.type) return 'default'
      return this.channel.landing.type
    }
  },
  data () {
    return {
      loading: true,
      err: false
    }
  },
  mounted () {
    if (this.$route.query.s) {
      // If they just signed up, re-load channel to show new content
      this.loadChannel()
    }
  },
  created () {
    this.loadChannel()

    if (this.$route.query.p) {
      this.$router.push({ name: 'page', params: { page_id: this.$route.query.p }})
    }
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.handleLoginShortcut)
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  $overhang-width: 32px;

  .error {
    @include error-title;
  }

  .channel-main {
    position: relative;
    left: $sidebar-width;
    width: calc(100% - #{$sidebar-width});
    height: 100%;
    overflow-x: hidden;
    // box-shadow: $boxShadow;
    background: $color-white;
    bottom: 0;
    position: absolute;
    overflow-y: scroll;
  }

  .channel-loading {
    max-width: 40rem;
    margin: 10% auto;
  }

  @import "../../assets/styles/mobile.scss";
</style>
